import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { TransfersOmniEventType } from './transfers-omni.event.type';
import { TweenMax, Quint } from 'gsap';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { FormGroup } from '@angular/forms';
import { EventTypes } from '../../shared/EventTypes';
import { Transfer } from '../models/transfer';
import { LimitsService } from '../limits/limits.service';
import * as moment from 'moment';
import { ModalErrorEventType } from '../../shared/modal-error/modal-error.event.type';
import { SharedService } from '../../shared/shared.service';

@Component({
	selector: 'app-transfers-omni',
	templateUrl: './transfers-omni.component.html',
	styleUrls: ['./transfers-omni.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransfersOmniComponent implements OnInit, OnDestroy {

	private form: FormGroup;
	private flow: Array<string> = [
		TransfersOmniEventType.STEPS.FAVORED_DATA,
		TransfersOmniEventType.STEPS.TRANSFER_DATA,
		TransfersOmniEventType.STEPS.TRANSFER_CONFIRMATION
	];
	private canSend = false;
	private isModal = false;

	public flowIndex = 0;
	public transferData = new Transfer();
	public hasSubmited = false;
	public showBalance = true;
	public showStepButtons = true;
	public scheduleSpan = false;
	public activeBackButton = false;
	public title = [
		'Transferência entre Contas',
		'Transferência entre Contas',
		'Confirmação de Transferência Entre Contas',
		'Resumo da Transferência Entre Contas'
	];
	public subtitle = [
		'Transferência financeira entre contas do Omni Banco.',
		'Transferência financeira entre contas do Omni Banco.',
		'Transferência financeira entre contas do Omni Banco.',
		'Transferência financeira entre contas do Omni Banco.'
	];

	constructor(private sharedService: SharedService) { }

	ngOnInit() {
		TweenMax.delayedCall(.3, () => {
			AppEventDispatcher.dispatch(this.flow[this.flowIndex], { show: true });
			this.show();
		});

		AppEventDispatcher.listen(TransfersOmniEventType.INIT, (data) => {
			this.sharedService.changeRerender(true);
		});

		AppEventDispatcher.listen(TransfersOmniEventType.ACTIONS.BUTTONS, data => {

			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});

		});

		/**
		 * Escuta se o passo atual tornou algum erro, se sim,
		 * seta o index para o mesmo passo e não incremeta o flow index, mantendo o step atual.
		 */
		AppEventDispatcher.listen(TransfersOmniEventType.ERROR, (data): any => {

			this.flowIndex = this.flow.findIndex((item, index, array) => {
				if (item === data.step) {
					return true;
				} else {
					return false;
				}
			});

			this.hasSubmited = false;
			this.canSend = false;
		});

		AppEventDispatcher.listen(TransfersOmniEventType.STEPS.TRANSFER_RESULT, data => {
			this.showStepButtons = true;
		});

		this.listenModal();
	}

	listenModal() {
		AppEventDispatcher.listen(ModalErrorEventType.MODAL.CANCEL, () => {
			this.canSend = false;
		}
		);

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.OK, () => {
			this.readySend();
		}
		);

		AppEventDispatcher.listen(TransfersOmniEventType.MODAL.TRUE_MODAL, (data) => {
			this.isModal = data.data;
		}
		);
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOmniEventType.ACTIONS.BUTTONS);
		AppEventDispatcher.removeListener(TransfersOmniEventType.ERROR);
		AppEventDispatcher.removeListener(TransfersOmniEventType.MODAL.TRUE_MODAL);
		AppEventDispatcher.removeListener(TransfersOmniEventType.STEPS.TRANSFER_RESULT);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.OK);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.CANCEL);
	}

	onSetTitleSubtitle(data) {
		this.title[this.flowIndex] = data.title;
		this.subtitle[this.flowIndex] = data.subtitle;
	}

	onSetForm(form: FormGroup) {
		this.form = form;
		this.canSend = false;
	}

	show() {
		TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});
		AppEventDispatcher.dispatch(EventTypes.BALANCE, {show: true});
	}

	readySend() {
		if (this.form.controls.favoredSelect && !this.form.controls.favoredSelect.valid) {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK,
				{ msg: 'Selecione um favorecido!' });
		} else {

			this.hasSubmited = true;

			if (this.form.valid && !this.canSend) {

				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { hide: true });

				this.canSend = true;

				if (this.flow[this.flowIndex] === TransfersOmniEventType.STEPS.TRANSFER_DATA) {

					this.flowIndex++;
					this.hasSubmited = false;
					AppEventDispatcher.dispatch(TransfersOmniEventType.TRANSFER.SEND, {});

					this.showStepButtons = false;

				} else {
					AppEventDispatcher.dispatch(this.flow[this.flowIndex], { show: false });
					this.flowIndex++;
					this.hasSubmited = false;

					// aguarda acabar a animação de saída da view atual, para iniciar a próxima
					TweenMax.delayedCall(.5, () => {
						AppEventDispatcher.dispatch(this.flow[this.flowIndex], { show: true });
					});
				}
			}
		}

	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="transfers-omni"] .content', show: active, delay: delay });
	}

	sendForm(event) {
		this.readySend();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-omni/transfers-omni.component.ts